module.exports = __webpack_public_path__ + "static/flags/CU-676cac30a95df84be74558ef2f6f20c2.gif";